module.exports = __webpack_public_path__ + "4f3eed8c1a33d584ca4d32f2aadfb0ad.MP3";